import store from './../../store';

let DAOItems = function () {
    this.getBasicCatalogItems = function(catalogId, stoneType) {
        return new Promise((resolve) => {
            let url		= store.getters["config/getOrderPlatformHost"] + "/order/api/diamondbourse/Api.php";
            let data	= new FormData();

            data.append('catalogId', catalogId);
            data.append('stoneType', stoneType);

            fetch(url, {
                method: 'post',
                body: data
            }).then(response => {
                response.json().then(json => {
                    if (typeof json === 'object') {
                       json = this.formatProductList(json);
                    }
                    resolve(json);
                });
            });
        });
    }

     this.formatProductList = (items) => {
        let itemList = [];
        for (let id in items) {
            itemList[id]= {
                setId: items[id].setId,
                jewelleryType: items[id].jewelleryType,
                oldItemnumber: items[id].itemnumber1
            };
        }
        return itemList;
    }
}

export default new DAOItems();
